import EventRsvpNotes from '@/screens/EventRsvpNotes';

export default function PrivateEventEventIdRsvpNotesRoute() {
  return <EventRsvpNotes />;
}
